import { Navigate, useNavigate, useParams } from 'react-router';

import { QuizBuilderContextProvider } from '@/context/quiz-builder';
import { useBeforeUnload } from '@/hooks/before-unload';
import QuizBuilderLayout from '@/layout/QuizBuilderLayout';

export default function QuizBuilderPage() {
  const { quizId } = useParams();
  const navigate = useNavigate();
  useBeforeUnload(true);

  if (quizId) {
    return (
      <QuizBuilderContextProvider quizId={quizId} navigateSection={(n) => navigate(n)}>
        <QuizBuilderLayout />
      </QuizBuilderContextProvider>
    );
  }
  return <Navigate to="/manage/quizzes" />;
}
